export function calcIcon(rankPercentage: number): string {
  if (rankPercentage >= 0 && rankPercentage <= 1) {
    return 'crown';
  } else if (rankPercentage > 1 && rankPercentage <= 5) {
    return 'crown';
  } else if (rankPercentage > 5 && rankPercentage <= 20) {
    return 'crown';
  } else if (rankPercentage > 20 && rankPercentage <= 40) {
    return 'medal';
  } else if (rankPercentage > 40 && rankPercentage <= 60) {
    return 'medal';
  } else if (rankPercentage > 60 && rankPercentage <= 80) {
    return 'medal';
  } else if (rankPercentage > 80 && rankPercentage <= 100) {
    return 'medal';
  }
  return 'medal';
}

export function calcIconColor(rankPercentage: number): string {
  if (rankPercentage >= 0 && rankPercentage <= 1) {
    return '--gold-500';
  } else if (rankPercentage > 1 && rankPercentage <= 5) {
    return '--silver-500';
  } else if (rankPercentage > 5 && rankPercentage <= 20) {
    return '--bronze-500';
  } else if (rankPercentage > 20 && rankPercentage <= 40) {
    return '--gold-500';
  } else if (rankPercentage > 40 && rankPercentage <= 60) {
    return '--silver-500';
  } else if (rankPercentage > 60 && rankPercentage <= 80) {
    return '--bronze-500';
  } else if (rankPercentage > 80 && rankPercentage <= 100) {
    return '--white';
  }
  return '--white';
}
